import { Button as MuiButton, DialogContent, styled } from '@mui/material';
import { spacing } from '@mui/system';
import React from 'react';

import { Dialog } from '../../components/dialog';

const Button = styled(MuiButton)(spacing);

type Props = {
  content: React.ReactNode;
  onClose?: () => void;
  okLabel?: string;
  onOk: () => void;
  title: string;
};

const OkDlg: React.FC<Props> = ({ content, onClose, okLabel, onOk, title }: Props) => {
  return (
    <Dialog title={title} onClose={onClose} fullWidth maxWidth="xs">
      <DialogContent dividers>
        {content}

        <Button color="primary" size="large" onClick={onOk} fullWidth variant="contained" mt={4}>
          {okLabel ?? 'OK'}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export { OkDlg };
